module.exports = __webpack_public_path__ + "img/py.24b6b9b4.svg";